// removed by extract-text-webpack-plugin
module.exports = {"ButtonGroupWrapper":"CopyButton__-loca-__3aVb8","CopyNameButtonGroup":"CopyButton__-loca-__2R5xa","CopyPaypalButtonGroup":"CopyButton__-loca-__1sMXt","CopyOtherButtonGroup":"CopyButton__-loca-__2X8hX","NameCopyHelper":"CopyButton__-loca-__3sjCM","PaypalCopyHelper":"CopyButton__-loca-__ihjK7","OtherCopyHelper":"CopyButton__-loca-__k8GVL","Image":"CopyButton__-loca-__O3tem"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Buttons/CopyButton/CopyButton.css
// module id = 202
// module chunks = 0